import {
  CASE_GENERAL_FIELDS,
  CLIENT_FIELDS_EXCEPT_NOTES,
  type DefineRule,
  type RuleConditions,
} from "./ability-rule-conditions";

export const defineAutomationRules = (can: DefineRule, conditions: RuleConditions) => {
  can(["read", "changeStep", "transitionToLegalProcess", "resolveCaseException"], "Case");
  can("update", "Case", [...CASE_GENERAL_FIELDS, "contacts"]);
  can("deleteContacts", "Case");
  can(["create", "read", "delete", "readPrivate"], "Client");
  can("update", "Client", [...CLIENT_FIELDS_EXCEPT_NOTES]);
  can(
    [
      "create",
      "createPrimary",
      "read",
      "update",
      "updateMetadata",
      "createReminder",
      "assignOnCreate",
    ],
    "Task",
  );
  can(["startAnalysis", "emailAssignee"], "Task");
  can("execute", "Task", conditions.assignedTask);
  can("read", "Document", { visibleTo: "Automation" });
  can(["create", "broadcast"], "Notification");
};
